<template>
  <div
    class="asc-plot-manager-wrapper"
    data-automation-id="wrapper_plot_manager"
  >
    <asc-plot-manager
      v-model="plotName"
      :allow-add-to-issue="allowAddToIssue"
      :is-recommendation-tab="isRecommendationTab"
      :flight-data-attach-plot-to-mx-rec-permission="
        flightDataAttachPlotToMxRecPermission
      "
      :mx-rec-plot="mxRecPlot"
      :associating="associating"
      :associated="isPlotAssociated"
      :saving="saving"
      :editable="editable"
      :tabs-invalid="tabsInvalid"
      :title-disabled="isTitleDisabled"
      :action-buttons="actionButtons"
      :is-close-button-visible="isCloseButtonVisible"
      :is-duplicate-button-visible="isDuplicateButtonVisible"
      :is-associate-button-visible="isAssociateButtonVisible"
      :on-duplicate="handleDuplicatePagePlot"
      :on-add-to-issue="handleAddIssueToPagePlot"
      :on-remove="handleClosePagePlot"
      :on-save="handleSavePagePlot"
      @input="debounceInput"
    ></asc-plot-manager>
  </div>
</template>

<script>
import AscPlotManager from '@/components/molecules/AscPlotManager'
import { debounceShortTime, PLOT_UPDATE_MESSAGES } from '@/utilities/appConsts'
import _ from 'lodash'

export default {
  name: 'AscPlotManagerWrapper',

  components: {
    AscPlotManager,
  },

  props: {
    allowAddToIssue: {
      type: Boolean,
      default: false,
    },
    pagePlot: {
      type: Object,
      default: () => {},
    },
    mxRecPlot: {
      type: Boolean,
      default: false,
    },
    
    flightDataAttachPlotToMxRecPermission: {
      type: Boolean,
      default: true,
    },
    associating: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    tabsInvalid: {
      type: Boolean,
      default: false,
    },
    actionButtons: {
      type: Boolean,
      default: true,
    },
    isCloseButtonVisible: {
      type: Boolean,
      default: true,
    },
    isDuplicateButtonVisible: {
      type: Boolean,
      default: true,
    },
    isAssociateButtonVisible: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    onDuplicatePagePlot: {
      type: Function,
      default: () => {},
    },
    onAddIssueToPagePlot: {
      type: Function,
      default: () => {},
    },
    onClosePagePlot: {
      type: Function,
      default: () => {},
    },
    onSavePagePlot: {
      type: Function,
      default: () => {},
    },
    onApplyPagePlot: {
      type: Function,
      default: () => {},
    },
    onApplyInvalidPagePlot: {
      type: Function,
      default: () => {},
    },
    isRecommendationTab: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      plotName: this.pagePlot.title,
      maintenanceIssueIds: this.pagePlot.maintenanceIssueIds,
    }
  },

  computed: {
    isPlotAssociated() {
      return this.maintenanceIssueIds?.length > 0
    },

    isTitleDisabled() {
      return this.pagePlot.prepopulated
    },
  },

  watch: {
    pagePlot: {
      deep: true,
      handler(newPagePlot) {
        this.pagePlot = newPagePlot
        this.plotName = newPagePlot.title
        this.maintenanceIssueIds = newPagePlot.maintenanceIssueIds || []
      },
    },
  },

  methods: {
    debounceInput: _.debounce(function (e) {
      if (this.onApplyPagePlot) {
        this.onApplyPagePlot(
          this.pagePlot.id,
          this.pagePlot.plotTypeId,
          PLOT_UPDATE_MESSAGES.updatePlotTitle,
          e,
        )
      }
    }, debounceShortTime),

    handleClosePagePlot() {
      if (this.onClosePagePlot) {
        this.onClosePagePlot(this.pagePlot.id)
      }
    },
    handleDuplicatePagePlot() {
      if (this.onDuplicatePagePlot) {
        this.onDuplicatePagePlot(this.pagePlot.id)
      }
    },

    handleAddIssueToPagePlot() {
      if (this.tabsInvalid && this.onApplyInvalidPagePlot) {
        this.onApplyInvalidPagePlot()
      }
      if (this.onAddIssueToPagePlot && !this.tabsInvalid) {
        this.onAddIssueToPagePlot(this.pagePlot.id)
      }
    },
    handleSavePagePlot() {
      if (this.tabsInvalid && this.onApplyInvalidPagePlot) {
        this.onApplyInvalidPagePlot()
      }
      if (this.onSavePagePlot && !this.tabsInvalid) {
        this.onSavePagePlot(this.pagePlot.id, this.pagePlot.plotTypeId)
      }
    },
  },
}
</script>
